export const key = 'pieLabel'

export const process = (chart, config) => {
  if (config) {
    return chart.pieLabel(config)
  }
  return chart
}
